exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fixed-bottom-btn[data-v-ddb90ebe]{position:fixed;bottom:0;left:0;right:0;background-color:#f1f1f1;padding:15px;color:red;font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ddb90ebe","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/Profil.vue
// module id = 723
// module chunks = 0